export const ORG = {
  name: "NXT LEVEL ENTERPRISES",
  mobile: "7671050570",
  email: "support@nexways.in",
  address : "SY No 602/A/2 Edulaguda,Near bypass Miryalaguda, Nalgonda District, Miryalaguda, Telangana, 508207",
  website : "https://nexways.in/",
  web : "nexways.in",
  hours:"9AM to 6PM"
};

export const API_URL = 'https://nexways.in/rest/';
export const IMAGE_PATH = 'https://nexways.in/rest/uploads/';

// export const API_URL = 'http://localhost/nexways/';
// export const IMAGE_PATH = 'http://localhost/nexways/uploads/';

export const MAX_RESULTS = 10;

export const LOGOUT_TIME = 1000 * 60 * 24; //replace last value with how many minutes

export const categories = {
  1: "Industrial Machinery",
  2: "Household Goods",
  3: "Parcel Service / luggage transport (Not Available)",
  4: "Fresh Fruits / Vegetables / Coconut",
  5: "FMCG / Packed Food Products",
  6: "Healthcare / Pharmacy Products / Medicines",
  7: "Cement / Bricks / Sand",
  8: "Chemicals Powder / Liquid Barrels",
  9: "Agriculture Fertilizer (Not available)",
  10: "Electronic Goods / Home Appliances",
  11: "Paper / Packaging / Printed Material",
  12: "Electrical Transformer / Panels / Equipments",
  13: "Solar / Battery / Inverter Products",
  14: "Ceramic / Hardware Supplies",
  15: "Electrical Wires / Cables",
  16: "Books / Stationery / Toys / Gifts",
  17: "Aluminium / Steel / Metal Products",
  18: "Building scaffolding / Construction Material",
  19: "Paint / Houseware Supplies",
  20: "Textile / Garments",
  21: "Plastic / Pvc / Rubber Pipes",
  22: "Machine / Auto Parts",
  23: "Exhibitions / Event Supplies",
  24: "Furniture / Plywood / Laminates",
  25: "Go Karts / Dirt Bikes /Bulk E.V",
  26: "Pet Transport",
  27: "ODC Consignment",
  28: "Metal / Plastic Scrap",
  29: "Plants / Pots",
  30: "Spices / Dry fruits",
  31: "Manufacturing Plant Machines",
  32: "One Sooter or Bike",
  33: "Rice/Wheat/Grains",
  34: "Books",
  35: "Paper Roll / Packing items",
  36: "Others",
  37: "Marble / Granite",
  38: "Office shifting",
  39: "Led Sign Boards",
  40: "Frozen Items",
  41: "Old Servers / Computers / Laptops",
  42: "Animal Feeds",
  43: "Animals / livestock",
  44: "Drones / Robots",
  45: "Wood Chips & Waste items",
  46: "Cable Drums / Wire cable"
};

export const trucks = {
  1: "ACE / DOST / PICKUP (1.5 TON)",
  2: "EICHER 14FT (3.5 TON)",
  3: "EICHER 17FT (5 TON)",
  4: "EICHER 19FT (7 TON)",
  5: "20FT CONTAINER (6.5 TON)",
  6: "EICHER PRO 22FT (10 TON)",
  7: "32FT CONTAINER (7/8 TON)",
  8: "32FT CONTAINER (15 TON)",
  9: "20 / 32 / 40 FT All Side Open TRAILER",
  10: "SELECT TRUCK LATER",
  11: "LORRY/TAURUS (18/21/25 TON)",
  12: "32FT CONTAINER (18 TON)"
};


